import { render, staticRenderFns } from "./AmountAccessDoor.vue?vue&type=template&id=a3da0264&"
import script from "./AmountAccessDoor.vue?vue&type=script&lang=ts&"
export * from "./AmountAccessDoor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports